import { useSelector } from 'react-redux';
import { selectWhatsAppNumber, selectWhatsAppBusinessNumber } from '../redux/selectors/application-selectors';

const useWhatsAppUrl = (packageUrlWhatsapp = null) => {
  const whatsappNumber = useSelector(selectWhatsAppNumber);
  const whatsappBusinessNumber = useSelector(selectWhatsAppBusinessNumber);
  
  const finalWhatsAppNumber = whatsappBusinessNumber || whatsappNumber;
  const isBusiness = Boolean(whatsappBusinessNumber);
  
  let whatsappUrl = null;
  
  if (isBusiness && packageUrlWhatsapp) {
    whatsappUrl = packageUrlWhatsapp;
  } else if (finalWhatsAppNumber) {
    if (isBusiness) {
      whatsappUrl = `https://wa.me/${finalWhatsAppNumber}`;
    } else {
      whatsappUrl = `https://api.whatsapp.com/send/?phone=${finalWhatsAppNumber}`;
    }
  }
  
  return {
    whatsappUrl,
    isBusiness,
    finalPhoneNumber: finalWhatsAppNumber,
  };
};

export default useWhatsAppUrl;

